import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import {
    InterfacePriorityFilter,
    InterfaceTypeFilter,
    NetworkDeviceFilter,
    SiteFilter,
    StatusFilter,
    TimeRangeFilter,
} from '../../filters';
import { InterfaceListPanel } from '../../panels';

export const pageId = 'interfaces';

export default function InterfacesPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Interfaces`}>
                <FilterContainer>
                    <TimeRangeFilter required />
                    <InterfacePriorityFilter />
                    <InterfaceTypeFilter />
                    <NetworkDeviceFilter />
                    <SiteFilter />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <InterfaceListPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
